import React from 'react';

const Gallery = () => {
  const galleryImages = [
    {
      id: 1,
      url: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?q=80&w=1000&auto=format&fit=crop',
      alt: 'Professional haircut service',
      category: 'Haircuts'
    },
    {
      id: 2,
      url: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?q=80&w=1000&auto=format&fit=crop',
      alt: 'Beard grooming service',
      category: 'Beard Styling'
    },
    {
      id: 3,
      url: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?q=80&w=1000&auto=format&fit=crop',
      alt: 'Luxury barber chair',
      category: 'Shop Interior'
    },
    {
      id: 4,
      url: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?q=80&w=1000&auto=format&fit=crop',
      alt: 'Premium barbering tools',
      category: 'Professional Tools'
    },
    {
      id: 5,
      url: 'https://images.unsplash.com/photo-1605497788044-5a32c7078486?q=80&w=1000&auto=format&fit=crop',
      alt: 'Modern skin fade',
      category: 'Haircuts'
    },
    {
      id: 6,
      url: 'https://images.unsplash.com/photo-1493256338651-d82f7acb2b38?q=80&w=1000&auto=format&fit=crop',
      alt: 'Classic barber shop interior',
      category: 'Shop Interior'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#0B0B0B] mb-4 font-playfair">Our Work</h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Explore our craftsmanship and premium grooming results</p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-lg aspect-square cursor-pointer"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 w-full">
                  <p className="text-[#C9A227] font-semibold uppercase tracking-wide text-sm mb-1">{image.category}</p>
                  <p className="text-white text-lg font-bold">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 text-lg mb-2">Experience the Mark's Barber difference</p>
          <p className="text-[#C9A227] font-semibold">Book your appointment today</p>
        </div>
      </div>
    </section>
  );
};

export default Gallery;